<script setup lang="ts">
import { ElAlert as ElementPlusAlert, alertProps } from 'element-plus'
import { WarnTriangleFilledIcon } from '@shared/assets/icons.js'

const props = defineProps(alertProps)
</script>

<template>
  <element-plus-alert v-bind="{ ...$attrs, ...props }">
    <template v-for="(_, name) in $slots" #[name]="data">
      <slot :name="name" v-bind="data || {}" />
    </template>
    <template v-if="props.type === 'warning' && !$slots.icon" #icon>
      <warn-triangle-filled-icon />
    </template>
  </element-plus-alert>
</template>
